import {
    MainFilterSelectedValuesApiType,
    MainFilterSelectedValuesIdsKeyEnum,
} from '../../service/main-filter/main-filter-api-type';
import {
    caseForActive,
    caseForOpen,
    getGroupsOperationValue,
    getIsPaidValue,
    getNeedModerateValue,
    getPriorityPlacementValue,
    getSuggestionIds,
    serializeIsPaid,
    serializeNeedModerate,
    serializePriorityPlacement,
} from '../../service/main-filter/main-filter-helper';
import {MainFilterFieldNameEnum, MainFiltersStateType} from '../../service/main-filter/main-filter-type';

export function serializeStateFromCompaniesCountRequest(state: MainFiltersStateType): MainFilterSelectedValuesApiType {
    const suggestIdFromSelectedValues = caseForOpen(state[MainFilterFieldNameEnum.CLOSED]);
    const suggestIdFromActiveValues = caseForActive(state[MainFilterFieldNameEnum.ACTIVE]);
    const priorityPlacementValue = serializePriorityPlacement(
        getPriorityPlacementValue(state[MainFilterFieldNameEnum.IS_PRIORITY_PLACEMENT])
    );
    const isPaidValue = serializeIsPaid(getIsPaidValue(state[MainFilterFieldNameEnum.IS_PAID]));

    const needModerateValue = serializeNeedModerate(getNeedModerateValue(state[MainFilterFieldNameEnum.NEED_MODERATE]));

    return {
        [MainFilterSelectedValuesIdsKeyEnum.BRANDS]: getSuggestionIds(state[MainFilterFieldNameEnum.BRANDS]),
        [MainFilterSelectedValuesIdsKeyEnum.CITIES]: getSuggestionIds(state[MainFilterFieldNameEnum.CITIES]),
        [MainFilterSelectedValuesIdsKeyEnum.CODES]: getSuggestionIds(state[MainFilterFieldNameEnum.CODES]),
        [MainFilterSelectedValuesIdsKeyEnum.COUNTRIES]: getSuggestionIds(state[MainFilterFieldNameEnum.COUNTRIES]),
        [MainFilterSelectedValuesIdsKeyEnum.GROUPS]: getSuggestionIds(state[MainFilterFieldNameEnum.GROUPS]),
        [MainFilterSelectedValuesIdsKeyEnum.GROUPS_LOGICAL_OPERATION]: getGroupsOperationValue(
            state[MainFilterFieldNameEnum.GROUPS_LOGICAL_OPERATION]
        ),
        [MainFilterSelectedValuesIdsKeyEnum.NAMES]: getSuggestionIds(state[MainFilterFieldNameEnum.NAMES]),
        [MainFilterSelectedValuesIdsKeyEnum.REGIONS]: getSuggestionIds(state[MainFilterFieldNameEnum.REGIONS]),
        [MainFilterSelectedValuesIdsKeyEnum.STREETS]: getSuggestionIds(state[MainFilterFieldNameEnum.STREETS]),
        ...suggestIdFromSelectedValues,
        ...suggestIdFromActiveValues,
        [MainFilterSelectedValuesIdsKeyEnum.PRIORITY_PLACEMENT]: priorityPlacementValue,
        [MainFilterSelectedValuesIdsKeyEnum.IS_PAID]: isPaidValue,
        [MainFilterSelectedValuesIdsKeyEnum.NEED_MODERATE]: needModerateValue,
    };
}
